module.exports = __webpack_public_path__ + "static/product_4-c7da67d9062f764d2185230a2d0c4f4e.png";